const init = () => {
    const SELECT_SELECTOR = 'select';

    const $select = $(SELECT_SELECTOR);

    $select.selectpicker();

}

export default {
    init
}